export default __webpack_public_path__ + "static/media/gift card_icon 1.395fb1e8.svg";